import React, { useState, useEffect } from 'react';
import ContenedorCamaFumigacion from './ContenedorCamaFumigacion';
import LineaDeAvance from './LineaDeAvance';

const ListadoCamasAvance = (p) => {
    const actualizarPadre = p.actualizarPadre ?? (() => { });
    const [camas, setcamas] = useState([...(p.camas ?? [])]);
    const fecha = p.fecha;
    const valvula = p.valvula ?? 0;
    var counter = 0;
    const keyGen = () => { counter++; return counter + "lista keygen" + valvula; }
    useEffect(() => {
        setcamas([...(p.camas ?? [])]);
    }, [p.camas]);

    const porcentajeAvance = (cm = [...camas]) => {
        if (cm.length === 0) return 0;
        let total = 0;
        cm.forEach(d => {
            if (d.refuerzo) total++;
        });
        return total / cm.length * 100;
    }

    return (
        <div className='w-100 p-1'>
            <LineaDeAvance avance={porcentajeAvance()} />
            <div className='row justify-content-start w-100 m-0 p-0 '>
                {camas.map((cama) =>
                    <React.Fragment key={keyGen()}>
                        <ContenedorCamaFumigacion
                            actualizarPadre={actualizarPadre}
                            cama={cama.cama}
                            valvula={valvula}
                            fecha={fecha}
                            refuerzo={cama.refuerzo} />
                    </React.Fragment>
                )}
            </div>
        </div>
    )
}

export default ListadoCamasAvance;